<div *ngIf="nudge" (click)="addAmount()" class="container">
  <div class="content">
    <span class="material-icons">favorite</span>
    <span class="title" [innerHTML]="data[number]?.text"></span>
    <span class="text" [innerHTML]="data[number]?.amount"></span>
  </div>
</div>